import Header from "@/pages/components/Header";
import Footer from "@/pages/components/Footer";
import WorkCard from "@/pages/components/WorkCard";
import { categories, works } from "@/mocks/manhwaData";

export default function Categories() {
  return (
    <>
      <Header />

      <main className="mx-auto w-full max-w-7xl px-4 py-10 md:px-6 md:py-14">
        {/* Breadcrumb */}
        <nav aria-label="面包屑导航" className="mb-6">
          <ol className="flex flex-wrap items-center gap-2 text-sm text-foreground-500">
            <li>
              <a href="/" className="transition-colors hover:text-primary-600">
                首页
              </a>
            </li>
            <li>
              <i className="ri-arrow-right-s-line"></i>
            </li>
            <li aria-current="page" className="text-foreground-800">
              题材分类
            </li>
          </ol>
        </nav>

        <header className="mb-10">
          <h1 className="font-heading text-3xl text-foreground-950 md:text-4xl">韩漫题材分类大全</h1>
          <p className="mt-4 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
            按类型、人气、榜单多维度整理推荐。从甜宠到悬疑、从奇幻到现实，八大核心题材集中展示，点击任意分类即可快速定位你想看的韩漫。
          </p>
        </header>

        <div className="space-y-14">
          {categories.map((cat, idx) => {
            const catWorks = works.filter((w) => w.categoryId === cat.id);
            return (
              <section
                key={cat.id}
                id={cat.id}
                className="scroll-mt-24"
              >
                <div className="flex flex-col gap-6 md:flex-row md:items-stretch">
                  <div className="group relative h-56 w-full overflow-hidden rounded-2xl border border-background-200/70 md:h-auto md:w-72 md:shrink-0">
                    <img
                      src={cat.cover}
                      alt={`${cat.name}韩漫分类`}
                      title={`${cat.name} · 韩漫题材分类`}
                      className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 to-transparent"></div>
                    <div className="absolute inset-x-0 bottom-0 flex items-end justify-between p-4">
                      <div>
                        <h2 className="font-heading text-xl text-background-50 md:text-2xl">
                          {cat.name}
                        </h2>
                        <p className="mt-1 text-xs text-background-100/85">{cat.desc}</p>
                      </div>
                      <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-background-50/20 text-background-50 backdrop-blur-sm">
                        <i className={cat.icon}></i>
                      </span>
                    </div>
                  </div>

                  <div className="flex-1">
                    <div className="flex flex-wrap items-center gap-2">
                      <span className="rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
                        {cat.count} 部作品
                      </span>
                      {idx < 3 && (
                        <span className="rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-900">
                          <i className="ri-fire-line mr-1"></i>
                          热门分类
                        </span>
                      )}
                    </div>
                    <div className="mt-4 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
                      {catWorks.slice(0, 4).map((work) => (
                        <WorkCard key={work.id} work={work} />
                      ))}
                    </div>
                    {catWorks.length > 4 && (
                      <p className="mt-4 flex items-center gap-1 text-xs text-foreground-500">
                        <i className="ri-more-fill"></i>
                        还有 {catWorks.length - 4} 部同题材作品
                      </p>
                    )}
                  </div>
                </div>
              </section>
            );
          })}
        </div>

        <section className="mt-16 rounded-3xl bg-accent-500 px-6 py-10 text-center md:px-10">
          <h2 className="font-heading text-2xl text-background-50 md:text-3xl">找不到想看的题材？</h2>
          <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-background-100/90">
            我们持续收录更多正版韩漫题材分类，热门分类与最新人气推荐会实时更新，欢迎常来看看，也可以在首页查看每日人气榜单。
          </p>
          <a
            href="/rankings"
            className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-background-50 px-6 py-3 text-sm font-semibold text-accent-700 transition-colors hover:bg-background-100"
          >
            <i className="ri-trophy-line"></i>
            前往人气榜单
          </a>
        </section>
      </main>

      <Footer />
    </>
  );
}